module.exports = __webpack_public_path__ + "assets/img/8.d75ea404.png";